import { useState } from 'react';

import Button from '../../components/Button';
import Text from '../../components/Text';
import { t } from '../../i18n/langue';

/** Au-delà, une transcription toujours vide n'arrivera plus : on n'annonce rien. */
const TRANSCRIPTION_EN_COURS_MS = 5 * 60 * 1000;

/**
 * Le message vocal d'un signalement, côté technicien : l'audio, sa traduction
 * française et, replié, ce que l'agent a dit dans sa langue. Équivalent mobile de
 * `pages/housekeeping/components/ReportVoiceMessage.tsx` (non importable).
 */
interface MessageVocalProps {
    audioUrl?: string | null;
    transcription?: string | null;
    traduction?: string | null;
    creeLe: string;
}

export default function MessageVocal({ audioUrl, transcription, traduction, creeLe }: MessageVocalProps) {
    const [origineOuverte, setOrigineOuverte] = useState(false);

    // Sans fichier audio, la transcription et la traduction restent lisibles :
    // seul le lecteur disparaît.
    if (!audioUrl && !transcription && !traduction) return null;

    // « En cours » n'a de sens que s'il y a un audio à transcrire.
    const enCours = !!audioUrl && !traduction && Date.now() - new Date(creeLe).getTime() < TRANSCRIPTION_EN_COURS_MS;
    const origineDistincte = !!transcription && transcription !== traduction;

    return (
        <section className="flex flex-col gap-2 rounded-xl bg-white px-3 py-3">
            <Text variante="sousTitre" as="h2">
                {t('maintenance.vocal.titre')}
            </Text>
            {audioUrl && <audio controls src={audioUrl} className="w-full" />}
            {traduction && <Text className="whitespace-pre-line">{traduction}</Text>}
            {enCours && (
                <div role="status">
                    <Text variante="petit" ton="attenue">
                        {t('maintenance.vocal.traductionEnCours')}
                    </Text>
                </div>
            )}
            {origineDistincte &&
                (origineOuverte ? (
                    <Text variante="petit" ton="attenue" className="whitespace-pre-line">
                        {transcription}
                    </Text>
                ) : (
                    <Button
                        libelle={t('maintenance.vocal.voirOrigine')}
                        variante="lien"
                        espacement="aucun"
                        alignement="debut"
                        ariaExpanded={false}
                        onPress={() => setOrigineOuverte(true)}
                    />
                ))}
        </section>
    );
}
